import React from 'react';
import { Link } from 'react-router-dom';
// styles
import styles from './SubscriptionNotice.mod.css';

const SubscriptionNotice = () => (
  <div className={styles.noticeWrapper}>
    <div className={styles.notice}>
      <p>
        Subscribe to LadderOut to get access - Go to{' '}
        <Link className={styles.link} to="/billing">
          Billing
        </Link>{' '}
        page
      </p>
    </div>
  </div>
);

export default SubscriptionNotice;



// WEBPACK FOOTER //
// ./src/components/SubscriptionNotice/SubscriptionNotice.jsx